"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class method decorator generator
 *
 * Replaces all methods of a given class with a version of it wrapped in a try / catch.
 *
 * The decorated function with run as normal, unless an error is encountered.
 *
 * When an error is encountered within one of the class methods, it will return an object with a message and the error object.
 *
 * This ensures that all errors thrown do not feed all the way back up, causing errors and possible render issues for the consumer.
 *
 * @param target Technically this could be anything, but we specifically use this to decorate Engine in the main export.
 */
function attachDecorators(target) {
    var e_1, _a;
    var _loop_1 = function (propName) {
        var descriptor = Object.getOwnPropertyDescriptor(target.prototype, propName);
        if (!descriptor)
            return "continue";
        var isMethod = descriptor.value instanceof Function;
        if (!isMethod)
            return "continue";
        var originalDescriptor = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                return originalDescriptor.apply(this, args);
            }
            catch (error) {
                return {
                    message: "FEA encountered an error within " + propName,
                    error: error,
                };
            }
        };
        Object.defineProperty(target.prototype, propName, descriptor);
    };
    try {
        for (var _b = __values(Object.keys(target.prototype)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var propName = _c.value;
            _loop_1(propName);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
exports.attachDecorators = attachDecorators;
